<template>
  <a
    class="link"
    @click.stop.prevent="handleClick"
  >
    <div class="link-container">
      <span>{{ i18n.t('callTarget.callResultDetailLink') }}</span>
      <BIcon>open_in_new</BIcon>
    </div>
  </a>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

type TProps = {
  callResultId: number;
};
const props = defineProps<TProps>();

const router = useRouter();
const i18n = useI18n();

const handleClick = () => {
  window.open(router.resolve({ name: 'Transcription', params: { callResultId: props.callResultId } }).href, '_blank');
};
</script>

<style lang="scss" scoped>
a.link {
  cursor: pointer;
  color: $textcolor-base;
  font-size: $fontsize-100;
}

.link-container {
  display: flex;
  align-items: center;
  gap: $basespace-50;
}
</style>
